import React from 'react';
import { FiX } from 'react-icons/fi';

interface RemoveUserModalProps {
  isOpen: boolean;
  memberName: string;
  onCancel: () => void;
  onConfirm: () => void;
}

const FiXComponent = FiX as unknown as React.ComponentType<{
  size?: number | string;
  className?: string;
}>;

const RemoveUserModal: React.FC<RemoveUserModalProps> = ({
  isOpen,
  memberName,
  onCancel,
  onConfirm,
}) => {
  if (!isOpen) return null;

  // Closes the modal without removing the user
  const handleCancel = () => {
    onCancel();
  };

  // Confirms the user removal and triggers the provided callback
  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className='fixed inset-0 flex items-center justify-center bg-black bg-opacity-40 z-50'>
      <div className='bg-white rounded-lg shadow-lg w-full max-w-lg p-6 relative'>
        {/* Close button */}
        <button
          onClick={handleCancel}
          className='absolute right-4 top-4 text-gray-500 hover:text-gray-700'
        >
          <FiXComponent size={20} />
        </button>

        <h2 className='text-[24px] font-semibold text-[#3F5265] mb-2'>
          Remove User
        </h2>
        <p className='text-[#657584] mb-4 text-[16px]'>
          This action will delete the member from your team and remove all
          assigned permissions.
        </p>

        {/* Warning box */}
        <div className='bg-red-50 text-red-700 rounded-md p-4 mb-6 text-[14px]'>
          <p className='font-medium mb-2'>
            This action will permanently remove{' '}
            <span className='font-semibold'>{memberName}</span> from your
            workspace.
          </p>
          <p className='mb-2'>
            They will lose all access immediately and must be re-invited if you
            wish to add them again.
          </p>
          <p className='font-medium'>This action cannot be undone.</p>
        </div>

        {/* Actions */}
        <div className='flex justify-end gap-3'>
          <button
            onClick={handleCancel}
            className='px-4 py-2 rounded border border-gray-300 text-gray-700 bg-white hover:bg-gray-100'
          >
            Cancel
          </button>
          <button
            onClick={handleConfirm}
            className='px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600'
          >
            Remove User
          </button>
        </div>
      </div>
    </div>
  );
};

export default RemoveUserModal;
